import axios from "axios";
import * as XLSX from "xlsx";
import { Role, Status } from "../../Redux/Actions/Role";
import moment from "moment";
const getStatusList = async (
  setStatusList,
  setStatusLoading,
  state,
  data,
  dispatch
) => {
  setStatusLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getStatusList_v1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: {
      RoleName: data,
    },
  })
    .then(async (res) => {
      setStatusList(res.data);
      setStatusLoading(false);
      // if (!state.Status) {
      let find = false;
      for (let i = 0; i < res.data.length; i++) {
        const item = res.data[i];
        if (state?.Status?.text === item?.text) {
          find = true;
        }
      }
      if (!find) {
        if(res?.data?.find((role) => role?.roleName === "Loam Approver")){
        const loamRole = res?.data?.find((role) => role?.roleName === "Loam Approver");
        dispatch(Status(loamRole));
        }else{
        dispatch(Status(res.data[0]));
      }
      }
      // }
    })
    .catch((err) => {
      setStatusLoading(false);
    });
};

const getRolesData = async (setRoles) => {
  await axios({
    method: "get", //you can set what request you want to be
    // url: `${`http://genialdemo-001-site9.itempurl.com`}/api/Authenticate/getUserRolesById`,
    url: `${process.env.REACT_APP_API_URL}/api/Authenticate/getUserRolesById`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      setRoles(res.data);
    })
    .catch((err) => {});
};
const getUserRoles = async (
  setRoles,
  setRolesLoading,
  setStatusList,
  setStatusLoading,
  state,
  dispatch,
  setRolesNavigate
) => {
  setRolesLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    // url: `${`http://genialdemo-001-site9.itempurl.com`}/api/Authenticate/getUserRolesById`,
    url: `${process.env.REACT_APP_API_URL}/api/Authenticate/getUserRolesById`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      setRoles(res.data);
      setRolesNavigate(res.data);
      setRolesLoading(false);
      if (state?.Status === "") {
        const loamRole = res?.data?.find((role) => role?.roleName === "Loam Approver");
        if (loamRole) {
          dispatch(Role(loamRole));
          getStatusList(
          setStatusList,
          setStatusLoading,
          state,
          loamRole.roleName,
          dispatch
        );
        }else{
        dispatch(Role(res.data[0]));
        getStatusList(
          setStatusList,
          setStatusLoading,
          state,
          res.data[0]?.roleName,
          dispatch
        );
        }
      } else {
        getStatusList(
          setStatusList,
          setStatusLoading,
          state,
          state?.roleName,
          dispatch
        );
      }
      // if (!state.RoleId) {

      //   dispatch(Role(res.data[0]));
      //   getStatusList(
      //     setStatusList,
      //     setStatusLoading,
      //     state,
      //     res.data[0]?.roleName,
      //     dispatch
      //   );
      // } else {
      //   getStatusList(
      //     setStatusList,
      //     setStatusLoading,
      //     state,
      //     state?.roleName,
      //     dispatch
      //   );
      // }
    })
    .catch((err) => {
      setRolesLoading(false);
    });
};

const getInvoices = async (
  setInvoices,
  setInvoiceLoading,
  invoiceData,
  setCount
) => {
  const stringified = JSON.stringify(invoiceData);
  const parsed = JSON.parse(stringified);

  let data = parsed;
  data.RoleId = parsed.RoleId?.roleId || "";
  data.Vendor = parsed.Vendor?.Vendor_Code || "-1";
  data.Status = parsed?.Status?.status;
  setInvoiceLoading(true);
  await axios({
    method: "post", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getLandingPageOnRoleWise`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
    // data: data,
  })
    .then(async (res) => {
      setInvoices(res?.data?.listRecord);
      setCount(parseInt(res?.data?.recordsCount[0].TotalNumberOfRecords));
      setInvoiceLoading(false);
    })
    .catch((err) => {
      setInvoiceLoading(false);
    });
};
// 2nd get invoices for landing page
let controller = null;
const getInvoicesLandingPage = async (
  setInvoices,
  setInvoiceLoading,
  invoiceData,
  setCount,
  status,
  isOrderUpdated
) => {
  if (controller) {
    controller.abort();
  }
  controller = new AbortController();
  setInvoices([]);
  const stringified = JSON.stringify(invoiceData);
  const parsed = JSON.parse(stringified);
  let data = parsed;
  data.RoleId = parsed.RoleId?.roleId || "";
  // data.RoleId = newValue?.roleId
  // data.roleName = newValue?.roleName
  data.Vendor = parsed.Vendor?.Vendor_Code || "-1";
  // data.Status = parsed?.Status?.text;
  data.Status = status?.text;
  data.InvoiceFromDate = parsed.InvoiceFromDate
    ? parsed.InvoiceFromDate
    : "1999-01-01";
  data.InvoiceToDate = parsed.InvoiceToDate
    ? parsed.InvoiceToDate
    : "9999-12-31";
    let orderBy = data.OrderBy;
    if (status?.text === "Processed" && data?.roleName=== "AP Supervisor" && isOrderUpdated) {
      console.log("update")
      data.OrderBy = "Updated_On";
     
    } else {
      console.log("order")
      // If not the first time or conditions are not met, set default order
      data.OrderBy = orderBy;
     
    }
    // data.OrderBy = (status?.text === "Processed" && data?.roleName === "AP Supervisor") ?  "Updated_On":  data.OrderBy;
  setInvoiceLoading(true);

  await axios({
    method: "post", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/getLandingPageOnRoleWise_v1`,
    signal: controller.signal,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
    // data: data,
  })
    .then(async (res) => {
      setInvoices(res?.data?.listRecord);
      setCount(parseInt(res?.data?.recordsCount));
      setInvoiceLoading(false);
    })
    .catch((err) => {
      setInvoiceLoading(false);
    });
};
function addZeroToString(str) {
  if (str?.length === 1) {
    return "0" + str;
  }
  return str;
}
const fun = (obj, noOfLoops, worksheet) => {
  let n = 1;
  for (let i = 0; i < noOfLoops.length; i++) {
    n = n + 1;
    const objName = obj + n;
    if (worksheet[objName]?.w) {
      const d = worksheet[objName].w?.split("/");
      worksheet[objName].v =
        addZeroToString(d[2]) + addZeroToString(d[1]) + addZeroToString(d[0]);
    }
  }
  // return worksheet;
};
const sendBulkInvoice = async (
  worksheet,
  inputRef,
  roleName,
  noOfLoops,
  setErrorMessage,
  setSuccessMessage,
  dispatch,
  statusList,
  state,
  setUploadLoading,
  setAlertList,
  setAlertMessage
) => {
  setUploadLoading(true);
  let invalid = false;
  if (roleName === "IR") {
    let { A1, B1, C1, D1, E1, F1, G1, H1, I1, J1, K1, L1, M1 } = worksheet;
    if (
      A1 &&
      B1 &&
      C1 &&
      D1 &&
      E1 &&
      F1 &&
      G1 &&
      H1 &&
      I1 &&
      J1 &&
      K1 &&
      L1 &&
      M1
    ) {
      A1.v = "pysical_EInvoice";
      A1.w = "pysical_EInvoice";
      B1.v = "urgent";
      B1.w = "urgent";
      C1.v = "skip_Tax_Team";
      C1.w = "skip_Tax_Team";
      D1.v = "vendor_Financing";
      D1.w = "vendor_Financing";
      E1.v = "pO_NonePO";
      E1.w = "pO_NonePO";
      F1.v = "invoice_Number";
      F1.w = "invoice_Number";
      G1.v = "invoice_Date";
      G1.w = "invoice_Date";
      fun("G", noOfLoops, worksheet);
      H1.v = "invoice_Description";
      H1.w = "invoice_Description";
      I1.v = "invoice_Amount";
      I1.w = "invoice_Amount";
      J1.v = "pO_Number";
      J1.w = "pO_Number";
      K1.v = "tax_Team";
      K1.w = "tax_Team";
      L1.v = "iP_Team";
      L1.w = "iP_Team";
      M1.v = "comments";
      M1.w = "comments";
    } else {
      invalid = true;
    }
  } else if (roleName === "I2P Initiator" ||   roleName === "Department Coordinator") {
    let { A1, B1, C1, D1, E1, F1, G1 } = worksheet;
    if (A1 && B1 && C1 && D1 && E1 && F1 && G1) {
      A1.v = "pO_NonePO";
      A1.w = "pO_NonePO";
      B1.v = "invoice_Number";
      B1.w = "invoice_Number";
      C1.v = "invoice_Date";
      C1.w = "invoice_Date";
      fun("C", noOfLoops, worksheet);
      D1.v = "invoice_Description";
      D1.w = "invoice_Description";
      E1.v = "invoice_Amount";
      E1.w = "invoice_Amount";
      F1.v = "pO_Number";
      F1.w = "pO_Number";
      G1.v = "comments";
      G1.w = "comments";
    } else {
      invalid = true;
    }
  }
  const json = XLSX.utils.sheet_to_json(worksheet);

  let temp = [];
  let errorList = [];
  let wrongFile = false;

  if (roleName === "I2P Initiator" || roleName === "Department Coordinator") {
    for (let i = 0; i < json.length; i++) {
      const item = json[i];

      // I2p excel file dont caontain tax team field so this will check either the file is valid or not
      if (item.hasOwnProperty("IP User")) {
        wrongFile = true;
      }
      // Invoice amount check
      if (!item?.invoice_Amount) {
        // wrongFile = true;
        const err = `Invoice Amount at row ${i + 2} is missing`;
        errorList.push(err);
      } else {
        if (isNaN(item?.invoice_Amount)) {
          const err1 = `Invoice Amount at row ${i + 2} is not a number`;
          errorList.push(err1);
        } else {
          item.invoice_Amount = item?.invoice_Amount?.toString() || "";
        }
      }

      // invoice Date check
      if (!item?.invoice_Date) {
        const err = `Invoice Date at row ${i + 2} is missing`;
        errorList.push(err);
      } else {
        let aDate = moment(item.invoice_Date, "YYDDMM", true);
        let isValid = aDate.isValid();
        if (isValid) {
          // if(item.invoice_Date)
          item.invoice_Date = moment(item?.invoice_Date, "YYDDMM").format(
            "YYYY-MM-DD"
          );
        } else {
          const err = `Invoice Date at row ${i + 2} is invalid`;
          errorList.push(err);
        }
      }
      // invoice Description check
      if (!item?.invoice_Description) {
        // wrongFile = true;
        const err = `Invoice Description at row ${i + 2} is missing`;
        errorList.push(err);
      } else {
        item.invoice_Description = item?.invoice_Description?.toString();
      }

      if (!item?.invoice_Number) {
        // wrongFile = true;
        const err = `Invoice Number at row ${i + 2} is missing`;
        errorList.push(err);
      } else {
        item.invoice_Number = item?.invoice_Number
          ?.toString()
          .replace(/\//g, "");
      }
      // Invoice PO/Non PO check
      if (!item?.pO_NonePO) {
        // wrongFile = true;
        const err = `Invoice PO/Non Po at row ${i + 2} is missing`;
        errorList.push(err);
      } else {
        if (item?.pO_NonePO == "PO" || item?.pO_NonePO == "Non PO") {
          item.pO_NonePO = item?.pO_NonePO;
        } else {
          const err1 = `Invoice PO/Non Po at row ${i + 2} is Invalid`;
          errorList.push(err1);
        }
      }
      // Invoice PO Number check
      if (!item?.pO_Number) {
        // wrongFile = true;
        const err = `Invoice PO Number at row ${i + 2} is missing`;
        errorList.push(err);
      } else {
        if (isNaN(item?.pO_Number)) {
          const err1 = `Invoice PO Number at row ${i + 2} is not a number`;
          errorList.push(err1);
        } else {
          item.pO_Number = item?.pO_Number?.toString();
        }
      }

      // invoice Comment check
      if (!item?.comments) {
        // wrongFile = true;
        const err = `Invoice Comment at row ${i + 2} is missing`;
        errorList.push(err);
      } else {
        item.comments = item?.comments?.toString();
      }

      item.createdBy = "";
      item.pysical_EInvoice = "";
      item.skip_Tax_Team = "";
      item.tax_Team = "";
      item.urgent = "";
      item.vendor_Financing = "";
      item.iP_Team = "";
      temp.push(item);
    }
  } else {
    for (let i = 0; i < json.length; i++) {
      const item = json[i];
      // invoice IP Team check
      if (!item?.iP_Team) {
        // wrongFile = true;
        const err = `IP Team at row ${i + 2} is missing`;
        errorList.push(err);
      } else {
        item.iP_Team = item?.iP_Team;
      }
      // invoice Comments check
      if (!item?.comments) {
        // wrongFile = true;
        const err = `Comments at row ${i + 2} is missing`;
        errorList.push(err);
      } else {
        item.comments = item?.comments.toString();
      }
      // Invoice Amount Check
      if (!item?.invoice_Amount) {
        // wrongFile = true;
        const err = `Invoice Amount at row ${i + 2} is missing`;
        errorList.push(err);
      } else {
        if (isNaN(item?.invoice_Amount)) {
          const err1 = `Invoice Amount at row ${i + 2} is not a number`;
          errorList.push(err1);
        } else {
          item.invoice_Amount = item?.invoice_Amount?.toString();
        }
      }
      // invoice Description check
      if (!item?.invoice_Description) {
        // wrongFile = true;
        const err = `Invoice Description at row ${i + 2} is missing`;
        errorList.push(err);
      } else {
        item.invoice_Description = item?.invoice_Description?.toString();
      }

      // Invoice Number check
      if (!item?.invoice_Number) {
        // wrongFile = true;
        const err = `Invoice Number at row ${i + 2} is missing`;
        errorList.push(err);
      }
      //   else {
      //     if (isNaN(item?.invoice_Number)) {

      //       const err1 = `Invoice Number at row ${i + 2} is not a number`
      //       errorList.push(err1)
      //     }
      // }
      //
      else {
        item.invoice_Number = item?.invoice_Number
          ?.toString()
          .replace(/\//g, "");
      }
      // Invoice PO/Non PO check
      if (!item?.pO_NonePO) {
        // wrongFile = true;
        const err = `Invoice PO/Non Po at row ${i + 2} is missing`;
        errorList.push(err);
      } else {
        if (item?.pO_NonePO == "PO" || item?.pO_NonePO == "Non PO") {
          item.pO_NonePO = item?.pO_NonePO;
        } else {
          const err1 = `Invoice PO/Non Po at row ${i + 2} is Invalid`;
          errorList.push(err1);
        }
      }
      // Invoice PO Number check
      if (!item?.pO_Number) {
        // wrongFile = true;
        const err = `Invoice PO Number at row ${i + 2} is missing`;
        errorList.push(err);
      } else {
        if (isNaN(item?.pO_Number)) {
          const err1 = `Invoice PO Number at row ${i + 2} is not a number`;
          errorList.push(err1);
        } else {
          item.pO_Number = item?.pO_Number?.toString();
        }
      }
      // Invoice Pysical EInvoice check
      if (!item?.pysical_EInvoice) {
        // wrongFile = true;
        const err = `Pysical EInvoice at row ${i + 2} is missing`;
        errorList.push(err);
      } else {
        if (
          item?.pysical_EInvoice == "E-Invoice" ||
          item?.pysical_EInvoice == "Physical"
        ) {
          item.pysical_EInvoice = item?.pysical_EInvoice;
        } else {
          const err1 = `Pysical EInvoice  at row ${i + 2} is Invalid`;
          errorList.push(err1);
        }
      }
      // invoice Date check
      if (!item?.invoice_Date) {
        // wrongFile = true;
        const err = `Invoice Date at row ${i + 2} is missing`;
        errorList.push(err);
      } else {
        let aDate = moment(item.invoice_Date, "YYDDMM", true);
        let isValid = aDate.isValid();
        if (isValid) {
          // if(item.invoice_Date)
          item.invoice_Date = moment(item?.invoice_Date, "YYDDMM").format(
            "YYYY-MM-DD"
          );
        } else {
          const err = `Invoice Date at row ${i + 2} is invalid`;
          errorList.push(err);
        }
      }
      // Invoice Skip Tax Team Check
      if (!item?.skip_Tax_Team) {
        // wrongFile = true;
        const err = `Skip Tax Team at row ${i + 2} is missing`;
        errorList.push(err);
      } else {
        if (item?.skip_Tax_Team == "Yes" || item?.skip_Tax_Team == "No") {
          item.skip_Tax_Team = item?.skip_Tax_Team;
        } else {
          const err1 = `Skip Tax Team  at row ${i + 2} is Invalid`;
          errorList.push(err1);
        }
      }
      // Invoice Urgent Check
      if (!item?.urgent) {
        // wrongFile = true;
        const err = `Urgent at row ${i + 2} is missing`;
        errorList.push(err);
      } else {
        if (item?.urgent == "Yes" || item?.urgent == "No") {
          item.urgent = item?.urgent;
        } else {
          const err1 = `Urgent  at row ${i + 2} is Invalid`;
          errorList.push(err1);
        }
      }
      // Invoice Vendor Financing Check
      if (!item?.vendor_Financing) {
        // wrongFile = true;
        const err = `Vendor Financing at row ${i + 2} is missing`;
        errorList.push(err);
      } else {
        if (item?.vendor_Financing == "Yes" || item?.vendor_Financing == "No") {
          item.vendor_Financing = item?.vendor_Financing;
        } else {
          const err1 = `Vendor Financing  at row ${i + 2} is Invalid`;
          errorList.push(err1);
        }
      }
      //Invoice Tax Team Check

      if (!item?.tax_Team) {
        // wrongFile = true;
        const err = `Tax Team at row ${i + 2} is missing`;
        errorList.push(err);
      }
      item.createdBy = "";

      temp.push(item);
    }
  }

  inputRef.current.value = null;

  {
    errorList.length == 0 && !invalid && !wrongFile
      ? setUploadLoading(true)
      : setUploadLoading(false);
  }

  {
    if (errorList.length == 0 && !invalid && !wrongFile) {
      await axios({
        method: "post", //you can set what request you want to be
        url: `${process.env.REACT_APP_API_URL}/api/Invoices/BulkUploadIR`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "application/json",
        },
        data: temp,
      })
        .then(async (res) => {
          (state.roleName == "I2P Initiator" || roleName === "Department Coordinator")
            ? dispatch(Status(statusList[28]))
            : dispatch(Status(statusList[4]));
          setUploadLoading(false);
          setSuccessMessage("Invoices Upload Successfully");

          inputRef.current.value = null;
        })
        .catch((err) => {
          if (err?.response?.data) {
            setErrorMessage(err?.response?.data?.title || err?.response?.data);
          } else {
            setErrorMessage(err?.message);
          }
          inputRef.current.value = null;
          setUploadLoading(false);
          // setAttachInvoiceLoading(false);
        });
    } else {
      if (invalid == true || wrongFile == true) {
        setErrorMessage("Invalid File");
        setUploadLoading(false);
      } else {
        setAlertMessage(true);
        setAlertList(errorList);
        setUploadLoading(false);
      }
    }
  }
};

const downloadInvoicesAttachmentMergedPDF = async (
  invoices,
  setDownloadAttachmentLoading,
  setErrAlertMessage
) => {
  setDownloadAttachmentLoading(true);
  await axios({
    method: "post",
    // url: `http://192.168.202.198:9093/api/UploadFile/DownloadInvoicesAttachmentMergedPDF`,
    url: `${process.env.REACT_APP_API_URL}/api/UploadFile/DownloadInvoicesAttachmentMergedPDF`,
    data: invoices,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      setDownloadAttachmentLoading(false);

      // const pdfUrl = `${process.env.REACT_APP_API_URL}/` + res.data.filePath;
      const pdfUrl = `${process.env.REACT_APP_API_URL}/` + res.data;
      const link = document.createElement("a");

      link.href = pdfUrl; // URL received from the API
      link.setAttribute("download", "file.pdf"); // Name for the downloaded file
      link.target = "_blank";
      // Append the anchor element to the body
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      document.body.removeChild(link);
    })
    .catch(({ response }) => {
      setDownloadAttachmentLoading(false);
      setErrAlertMessage(response.data);
      console.log(response);
    });
};
export {
  getStatusList,
  getUserRoles,
  getRolesData,
  getInvoices,
  sendBulkInvoice,
  getInvoicesLandingPage,
  downloadInvoicesAttachmentMergedPDF,
};
